/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { Td, Tr } from "@lightspeed/cirrus-table";
import { Button } from "@lightspeed/flame/Button";
import { Input } from "@lightspeed/flame/Input";
import { Switch } from "@lightspeed/flame/Switch";
import { useDispatch, useSelector } from "react-redux";
import * as databaseActions from "../../../redux/actions/databaseActions";
import QuickBooksClassDepartmentField from "../QuickBooksClassDepartmentField";

const Row = ({ item, retail, accountsList, classList, customersList, showHiddenFields, hideClassDepartmentColumn = false }) => {
  const dispatch = useDispatch();
  const ui = useSelector((state) => state.ui);
  const userState = useSelector((state) => state.userState);
  const database = useSelector((state) => state.database);

  const [edit, setEdit] = useState(false);
  const [changed, setChanged] = useState(false);

  // GL / opis
  const [inputBox1, setInputBox1] = useState(""); // account_id
  const [inputBox2, setInputBox2] = useState(""); // account_description

  // Flash + COGS polja
  const [checkBox3, setCheckBox3] = useState(false); // flash
  const [inputBox4, setInputBox4] = useState(""); // cogs
  const [inputBox5, setInputBox5] = useState(""); // cogs_description
  const [inputBox6, setInputBox6] = useState(""); // cogs2 (Total)
  const [inputBox7, setInputBox7] = useState(""); // cogs_description2 (Total)

  // Class/Dep/Loc + Customer
  const [inputBox8, setInputBox8] = useState(""); // class_department_location
  const [inputBox9, setInputBox9] = useState(""); // qb_customer_id (tekst/ID)
  const [customerId, setCustomerId] = useState(""); // interni ID

  // RESTOK “K”
  const [kCogsId, setKCogsId] = useState("");
  const [kCogsName, setKCogsName] = useState("");

  // Normalizirane vrijednosti
  const normalAccount = item.account_id ?? "";
  const normalAccountDescription = item.account_description ?? "";
  const normalCheck = item.flash === "Yes";
  const normalCogs = item.cogs ?? "";
  const normalCogsDescription = item.cogs_description ?? "";
  const normalCogs2 = item.cogs2 ?? "";
  const normalCogsDescription2 = item.cogs_description2 ?? "";
  const normalCogsK = item.cogs_id ?? "";
  const normalCogsDescriptionK = item.cogs_name ?? "";
  const normalClassDeptLoc = item.class_department_location ?? "";
  const normalCustomer = item.qb_customer_id ?? "";

  // Dropdown stanja
  const [showDropdownAcc, setShowDropdownAcc] = useState(false);
  const [searchTextAcc, setSearchTextAcc] = useState("");

  const [showClassDropdown8, setShowClassDropdown8] = useState(false);
  const [classSearchText8, setClassSearchText8] = useState("");

  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [customerSearchText, setCustomerSearchText] = useState("");

  const [showDropdownCogs, setShowDropdownCogs] = useState(false);
  const [searchTextCogs, setSearchTextCogs] = useState("");

  const [showDropdownCogsTotal, setShowDropdownCogsTotal] = useState(false);
  const [searchTextCogsTotal, setSearchTextCogsTotal] = useState("");

  // Refs za fokus svakog dropdowna
  const accSearchRef = useRef(null);
  const classSearchRef = useRef(null);
  const customerSearchRef = useRef(null);
  const cogsSearchRef = useRef(null);
  const cogsTotalSearchRef = useRef(null);

  // Fokus kad se pojedini dropdown otvori
  useEffect(() => {
    if (showDropdownAcc) accSearchRef.current?.focus();
  }, [showDropdownAcc]);

  useEffect(() => {
    if (showClassDropdown8) classSearchRef.current?.focus();
  }, [showClassDropdown8]);

  useEffect(() => {
    if (showCustomerDropdown) customerSearchRef.current?.focus();
  }, [showCustomerDropdown]);

  useEffect(() => {
    if (showDropdownCogs) cogsSearchRef.current?.focus();
  }, [showDropdownCogs]);

  useEffect(() => {
    if (showDropdownCogsTotal) cogsTotalSearchRef.current?.focus();
  }, [showDropdownCogsTotal]);

  // Init
  useEffect(() => {
    setInputBox1(normalAccount);
    setInputBox2(normalAccountDescription);

    setCheckBox3(normalCheck);
    setInputBox4(normalCogs);
    setInputBox5(normalCogsDescription);
    setInputBox6(normalCogs2);
    setInputBox7(normalCogsDescription2);

    setInputBox8(normalClassDeptLoc);
    setInputBox9(normalCustomer);

    setCustomerId(item.customer_id ? String(item.customer_id) : "");

    setKCogsId(normalCogsK);
    setKCogsName(normalCogsDescriptionK);

    setEdit(false);
  }, [
    normalAccount,
    normalAccountDescription,
    normalCheck,
    normalCogs,
    normalCogsDescription,
    normalCogs2,
    normalCogsDescription2,
    normalClassDeptLoc,
    normalCustomer,
    normalCogsK,
    normalCogsDescriptionK,
    item.customer_id,
  ]);

  // Praćenje promjena
  useEffect(() => {
    const noChanges =
      normalAccount === inputBox1 &&
      normalAccountDescription === inputBox2 &&
      normalCheck === checkBox3 &&
      normalCogs === inputBox4 &&
      normalCogsDescription === inputBox5 &&
      normalCogs2 === inputBox6 &&
      normalCogsDescription2 === inputBox7 &&
      normalClassDeptLoc === inputBox8 &&
      normalCustomer === inputBox9;

    setChanged(!noChanges);
  }, [
    inputBox1,
    inputBox2,
    checkBox3,
    inputBox4,
    inputBox5,
    inputBox6,
    inputBox7,
    inputBox8,
    inputBox9,
    normalAccount,
    normalAccountDescription,
    normalCheck,
    normalCogs,
    normalCogsDescription,
    normalCogs2,
    normalCogsDescription2,
    normalClassDeptLoc,
    normalCustomer,
  ]);

  const handleUpdate = () => {
    const qbCustomerValue = (inputBox9 ?? "").toString().trim() || null;
    const internalCustomerId = (customerId ?? "").toString().trim() || null;

    if (database.currentCompany.type === "RETAIL") {
      dispatch(
        databaseActions.updateRetailCategoryDeferred(
          userState.user.user_id,
          item.company_id,
          database.currentShop.shop_id,
          inputBox1,
          inputBox2,
          item.category_id,
          checkBox3 ? "Yes" : "",
          inputBox4,
          inputBox5,
          inputBox6,
          inputBox7,
          inputBox8,
          inputBox9,
          inputBox9,
          databaseActions.getShopCategoriesDeferred(
            database.currentCompany.id,
            userState.user.user_id,
            database.currentShop.shop_id
          )
        )
      );
    }

    if (database.currentCompany.type === "RETAILX") {
      dispatch(
        databaseActions.updateRetailCategoryX(
          userState.user.user_id,
          item.company_id,
          database.currentShop.shop_id,
          inputBox1,
          inputBox2,
          item.category_id,
          checkBox3 ? "Yes" : "",
          inputBox4,
          inputBox5,
          inputBox6,
          inputBox7,
          inputBox8,
          inputBox9,
          inputBox9,
          databaseActions.getShopCategoriesX(
            database.currentCompany.id,
            userState.user.user_id,
            database.currentShop.shop_id
          )
        )
      );
    }

    if (database.currentCompany.type === "RESTOK") {
      if (database.currentCompany.direct) {
        dispatch(
          databaseActions.updateRestoCategoriesK(
            userState.user.user_id,
            item.company_id,
            item.category_id,
            inputBox1,
            inputBox2,
            0,
            inputBox4,
            inputBox5,
            inputBox6,
            inputBox7,
            inputBox8,
            inputBox9,
            inputBox9,
            0,
            undefined,
            databaseActions.patchCurrentAreaCategory(item.category_id, {
              account_id: inputBox1,
              account_description: inputBox2,
              cogs: inputBox4,
              cogs_description: inputBox5,
              cogs_id: inputBox4,
              cogs_name: inputBox5,
              cogs2: inputBox6,
              cogs_description2: inputBox7,
              cogs_name2: inputBox7,
              class_department_location: inputBox8,
              qb_customer_id: qbCustomerValue,
              customer_id: internalCustomerId,
            })
          )
        );
      } else {
        dispatch(
          databaseActions.updateRestoCategoriesK(
            userState.user.user_id,
            item.company_id,
            item.category_id,
            inputBox1,
            inputBox2,
            database.currentShop.area_id,
            inputBox4,
            inputBox5,
            inputBox6,
            inputBox7,
            inputBox8,
            inputBox9,
            inputBox9,
            0,
            undefined,
            databaseActions.patchCurrentAreaCategory(item.category_id, {
              account_id: inputBox1,
              account_description: inputBox2,
              cogs: inputBox4,
              cogs_description: inputBox5,
              cogs_id: inputBox4,
              cogs_name: inputBox5,
              cogs2: inputBox6,
              cogs_description2: inputBox7,
              cogs_name2: inputBox7,
              class_department_location: inputBox8,
              qb_customer_id: qbCustomerValue,
              customer_id: internalCustomerId,
            })
          )
        );
      }
    } else if (database.currentCompany.type === "RESTO") {
      if (database.currentCompany.direct) {
        dispatch(
          databaseActions.updateRestoCategories(
            userState.user.user_id,
            item.company_id,
            item.category_id,
            inputBox1,
            inputBox2,
            0,
            inputBox8,
            inputBox9,
            inputBox9,
            0,
            databaseActions.getAreaCategories(
              userState.user.user_id,
              database.currentCompany.id,
              0
            )
          )
        );
      } else {
        dispatch(
          databaseActions.updateRestoCategories(
            userState.user.user_id,
            item.company_id,
            item.category_id,
            inputBox1,
            inputBox2,
            database.currentShop.area_id,
            inputBox8,
            inputBox9,
            inputBox9,
            0,
            databaseActions.getAreaCategories(
              userState.user.user_id,
              database.currentCompany.id,
              database.currentShop.area_id
            )
          )
        );
      }
    }

    setEdit(false);
  };

  const filterBy = (list, term) => {
    const t = (term || "").toLowerCase();
    return (list || []).filter((x) => {
      const id = (x?.id ?? "").toString().toLowerCase();
      const desc = (x?.description ?? "").toString().toLowerCase();
      return id.includes(t) || desc.includes(t);
    });
  };

  const filteredAccountsAcc = filterBy(accountsList, searchTextAcc);
  const filteredClasses8 = (Array.isArray(classList) ? classList : classList?.classes || []).filter((cls) => {
    const id = (cls?.id ?? "").toString().toLowerCase();
    const desc = (cls?.description ?? "").toString().toLowerCase();
    const s = (classSearchText8 || "").toLowerCase();
    return id.includes(s) || desc.includes(s);
  });
  const filteredCustomers = filterBy(customersList, customerSearchText);
  const filteredAccountsCogs = filterBy(accountsList, searchTextCogs);
  const filteredAccountsCogsTotal = filterBy(accountsList, searchTextCogsTotal);

  return (
    <Tr
      textAlign="right"
      className={`${ui.theme === "flame" ? "" : "dark-table-row"}`}
      onDoubleClick={() => setEdit(true)}
    >
      <Td width="10%" className="td-pos">
        {item.company_id}
      </Td>

      <Td width="10%" className="td-pos">
        {item.category_id}
      </Td>

      <Td width="20%" className="td-pos td-pos-last">
        {item.category_name}
      </Td>

      {retail && (
        <Td width="8%" className="td-acc td-acc-first">
          {item.parentid}
        </Td>
      )}

      <Td
        width="10%"
        className={retail ? "td-acc" : "td-acc td-acc-first"}
        style={{ position: "relative" }}
      >
        {!edit ? (
          inputBox1
        ) : (
          <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
            <Input
              className="input-wrapper-row-inputbox"
              type="text"
              size="small"
              value={inputBox1}
              onChange={(e) => {
                setInputBox1(e.target.value);
                setChanged(true);
              }}
              onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
            />
            <span
              style={{ marginLeft: 4, cursor: "pointer", fontSize: 16, userSelect: "none" }}
              onClick={() => {
                setShowDropdownAcc((prev) => !prev);
                setSearchTextAcc("");
              }}
            >
              ⏷
            </span>

            {showDropdownAcc && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  background: "#fff",
                  zIndex: 1000,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  width: 450,
                  minWidth: "100%",
                  maxHeight: 200,
                  overflowY: "auto",
                  marginTop: 4,
                }}
              >
                <div style={{ padding: 4 }}>
                  <input
                    ref={accSearchRef}
                    type="text"
                    placeholder="Search..."
                    value={searchTextAcc}
                    onChange={(e) => setSearchTextAcc(e.target.value)}
                    style={{
                      width: "100%",
                      padding: 6,
                      fontSize: 14,
                      border: "1px solid #ccc",
                      borderRadius: 4,
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        const first = filteredAccountsAcc[0];
                        if (first) {
                          setInputBox1(first.id);
                          setInputBox2(first.description);
                          setChanged(true);
                          setShowDropdownAcc(false);
                          setSearchTextAcc("");
                        }
                      }
                    }}
                  />
                </div>

                {filteredAccountsAcc.map((acc) => (
                  <div
                    key={acc.id}
                    style={{ padding: "6px 8px", cursor: "pointer", borderBottom: "1px solid #eee" }}
                    onClick={() => {
                      setInputBox1(acc.id);
                      setInputBox2(acc.description);
                      setChanged(true);
                      setShowDropdownAcc(false);
                      setSearchTextAcc("");
                    }}
                  >
                    <strong>{acc.id}</strong> — {acc.description}
                  </div>
                ))}

                {filteredAccountsAcc.length === 0 && (
                  <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                )}
              </div>
            )}
          </div>
        )}
      </Td>

      <Td width="16%" className="td-acc">
        {!edit ? (
          inputBox2
        ) : (
          <Input
            className="input-wrapper-row-inputbox"
            type="text"
            size="small"
            value={inputBox2}
            onChange={(e) => {
              setInputBox2(e.target.value);
              setChanged(true);
            }}
            onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
          />
        )}
      </Td>

      <Td width="10%" className="td-acc" style={{ position: "relative", display: hideClassDepartmentColumn ? "none" : undefined }}>
        {!edit ? (
          <>
            {inputBox8}
            <div className="flex" />
          </>
        ) : (
          <QuickBooksClassDepartmentField
            value={inputBox8}
            onChange={(value) => {
              setInputBox8(value);
              setChanged(true);
            }}
            classDepartments={classList}
            onEnter={handleUpdate}
          />
        )}
      </Td>

      <Td width="10%" className="td-acc" style={{ position: "relative" }}>
        {!edit ? (
          inputBox9
        ) : (
          <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
            <Input
              className="input-wrapper-row-inputbox"
              type="text"
              size="small"
              value={inputBox9}
              onChange={(e) => {
                setInputBox9(e.target.value);
                setChanged(true);
              }}
              onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
            />
            <span
              style={{ marginLeft: 4, cursor: "pointer", fontSize: 16, userSelect: "none" }}
              onClick={() => {
                setShowCustomerDropdown((prev) => !prev);
                setCustomerSearchText("");
              }}
            >
              ⏷
            </span>

            {showCustomerDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  background: "#fff",
                  zIndex: 1000,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  width: 450,
                  minWidth: "100%",
                  maxHeight: 200,
                  overflowY: "auto",
                  marginTop: 4,
                }}
              >
                <div style={{ padding: 4 }}>
                  <input
                    ref={customerSearchRef}
                    type="text"
                    placeholder="Search..."
                    value={customerSearchText}
                    onChange={(e) => setCustomerSearchText(e.target.value)}
                    style={{
                      width: "100%",
                      padding: 6,
                      fontSize: 14,
                      border: "1px solid #ccc",
                      borderRadius: 4,
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        const first = filteredCustomers[0];
                        if (first) {
                          setInputBox9(String(first.id));
                          setCustomerId(String(first.id));
                          setChanged(true);
                          setShowCustomerDropdown(false);
                          setCustomerSearchText("");
                        }
                      }
                    }}
                  />
                </div>

                {filteredCustomers.map((c) => (
                  <div
                    key={c.id}
                    style={{ padding: "6px 8px", cursor: "pointer", borderBottom: "1px solid #eee" }}
                    onClick={() => {
                      setInputBox9(String(c.id));
                      setCustomerId(String(c.id));
                      setChanged(true);
                      setShowCustomerDropdown(false);
                      setCustomerSearchText("");
                    }}
                  >
                    <strong>{c.id}</strong> — {c.description}
                  </div>
                ))}

                {filteredCustomers.length === 0 && (
                  <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                )}
              </div>
            )}
          </div>
        )}
      </Td>

      {showHiddenFields && (
        <>
          <Td width="6%" className="td-acc">
            <Switch
              checked={checkBox3}
              onChange={() => {
                setEdit(true);
                setCheckBox3((prev) => !prev);
                setChanged(true);
              }}
            />
          </Td>

          <Td width="10%" className="td-acc" style={{ position: "relative" }}>
            {!edit ? (
              inputBox4
            ) : (
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <Input
                  size="small"
                  value={inputBox4}
                  onChange={(e) => {
                    setInputBox4(e.target.value);
                    setChanged(true);
                  }}
                  onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
                />
                <span
                  style={{ marginLeft: 4, cursor: "pointer", fontSize: 16, userSelect: "none" }}
                  onClick={() => {
                    setShowDropdownCogs((prev) => !prev);
                    setSearchTextCogs("");
                  }}
                >
                  ⏷
                </span>

                {showDropdownCogs && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "#fff",
                      zIndex: 1000,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      width: 450,
                      minWidth: "100%",
                      maxHeight: 200,
                      overflowY: "auto",
                      marginTop: 4,
                    }}
                  >
                    <div style={{ padding: 4 }}>
                      <input
                        ref={cogsSearchRef}
                        type="text"
                        placeholder="Search..."
                        value={searchTextCogs}
                        onChange={(e) => setSearchTextCogs(e.target.value)}
                        style={{
                          width: "100%",
                          padding: 6,
                          fontSize: 14,
                          border: "1px solid #ccc",
                          borderRadius: 4,
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            const first = filteredAccountsCogs[0];
                            if (first) {
                              setInputBox4(first.id);
                              setInputBox5(first.description);
                              setChanged(true);
                              setShowDropdownCogs(false);
                              setSearchTextCogs("");
                            }
                          }
                        }}
                      />
                    </div>

                    {filteredAccountsCogs.map((acc) => (
                      <div
                        key={`cogs-${acc.id}`}
                        style={{ padding: "6px 8px", cursor: "pointer", borderBottom: "1px solid #eee" }}
                        onClick={() => {
                          setInputBox4(acc.id);
                          setInputBox5(acc.description);
                          setChanged(true);
                          setShowDropdownCogs(false);
                          setSearchTextCogs("");
                        }}
                      >
                        <strong>{acc.id}</strong> — {acc.description}
                      </div>
                    ))}

                    {filteredAccountsCogs.length === 0 && (
                      <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                    )}
                  </div>
                )}
              </div>
            )}
          </Td>

          <Td width="12%" className="td-acc">
            {!edit ? (
              inputBox5
            ) : (
              <Input
                size="small"
                value={inputBox5}
                onChange={(e) => {
                  setInputBox5(e.target.value);
                  setChanged(true);
                }}
                onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
              />
            )}
          </Td>

          <Td width="10%" className="td-acc" style={{ position: "relative" }}>
            {!edit ? (
              inputBox6
            ) : (
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <Input
                  size="small"
                  value={inputBox6}
                  onChange={(e) => {
                    setInputBox6(e.target.value);
                    setChanged(true);
                  }}
                  onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
                />
                <span
                  style={{ marginLeft: 4, cursor: "pointer", fontSize: 16, userSelect: "none" }}
                  onClick={() => {
                    setShowDropdownCogsTotal((prev) => !prev);
                    setSearchTextCogsTotal("");
                  }}
                >
                  ⏷
                </span>

                {showDropdownCogsTotal && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "#fff",
                      zIndex: 1000,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      width: 450,
                      minWidth: "100%",
                      maxHeight: 200,
                      overflowY: "auto",
                      marginTop: 4,
                    }}
                  >
                    <div style={{ padding: 4 }}>
                      <input
                        ref={cogsTotalSearchRef}
                        type="text"
                        placeholder="Search..."
                        value={searchTextCogsTotal}
                        onChange={(e) => setSearchTextCogsTotal(e.target.value)}
                        style={{
                          width: "100%",
                          padding: 6,
                          fontSize: 14,
                          border: "1px solid #ccc",
                          borderRadius: 4,
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            const first = filteredAccountsCogsTotal[0];
                            if (first) {
                              setInputBox6(first.id);
                              setInputBox7(first.description);
                              setChanged(true);
                              setShowDropdownCogsTotal(false);
                              setSearchTextCogsTotal("");
                            }
                          }
                        }}
                      />
                    </div>

                    {filteredAccountsCogsTotal.map((acc) => (
                      <div
                        key={`cogsTotal-${acc.id}`}
                        style={{ padding: "6px 8px", cursor: "pointer", borderBottom: "1px solid #eee" }}
                        onClick={() => {
                          setInputBox6(acc.id);
                          setInputBox7(acc.description);
                          setChanged(true);
                          setShowDropdownCogsTotal(false);
                          setSearchTextCogsTotal("");
                        }}
                      >
                        <strong>{acc.id}</strong> — {acc.description}
                      </div>
                    ))}

                    {filteredAccountsCogsTotal.length === 0 && (
                      <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                    )}
                  </div>
                )}
              </div>
            )}
          </Td>

          <Td width="12%" className="td-acc">
            {!edit ? (
              inputBox7
            ) : (
              <Input
                size="small"
                value={inputBox7}
                onChange={(e) => {
                  setInputBox7(e.target.value);
                  setChanged(true);
                }}
                onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
              />
            )}
          </Td>
        </>
      )}

      <Td width="8%" textAlign="right" className="td-acc">
        {!edit ? (
          <Button size="small" fill="true" onClick={() => setEdit(true)}>
            Edit
          </Button>
        ) : (
          <Button size="small" fill="true" onClick={handleUpdate} disabled={!changed}>
            Update
          </Button>
        )}
      </Td>
    </Tr>
  );
};

export default Row;